import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const InfoIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7C12.5523 7 13 7.44772 13 8V8.02261C13 8.5749 12.5523 9.02261 12 9.02261C11.4477 9.02261 11 8.5749 11 8.02261V8C11 7.44772 11.4477 7 12 7ZM10.5 11.5C10.5 10.9477 10.9477 10.5 11.5 10.5C12.3284 10.5 13 11.1716 13 12V15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H11C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15V12.3662C10.7011 12.1933 10.5 11.8701 10.5 11.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

InfoIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(InfoIcon);
